var map = {
	"./bottom/bottom.svg": 7356,
	"./bottom/square.svg": 9852,
	"./bottom/tail.svg": 1971,
	"./bottom/tucked.svg": 2117,
	"./bottom/untucked.svg": 6148,
	"./button/button.svg": 1229,
	"./chestpocket/chestpocket.svg": 1772,
	"./chestpocket/chestpocket_standard.svg": 4108,
	"./chestpocket/double_standard.svg": 4216,
	"./chestpocket/double_with_flap.svg": 6019,
	"./chestpocket/no_pocket.svg": 1719,
	"./chestpocket/with_flap.svg": 5859,
	"./collar/button_down.svg": 9970,
	"./collar/collar.svg": 1572,
	"./collar/cutaway.svg": 5699,
	"./collar/kent.svg": 2937,
	"./collar/new_kent.svg": 1460,
	"./collar/pinned.svg": 4025,
	"./collar/rounded.svg": 3578,
	"./collar/short_classic.svg": 1938,
	"./collar/stand_up.svg": 7815,
	"./collar/wing.svg": 1578,
	"./cuffs/cuffs.svg": 5188,
	"./cuffs/double_square_french_cuff.svg": 3946,
	"./cuffs/one_button_cut.svg": 6191,
	"./cuffs/rounded_french_cuff.svg": 6926,
	"./cuffs/single_cuffs_two_button.svg": 1391,
	"./cuffs/square_french_cuff.svg": 7530,
	"./fit/fit.svg": 4404,
	"./fit/regular.svg": 2413,
	"./fit/slim_fit.svg": 3104,
	"./icon_add_circle.svg": 7435,
	"./icon_arrow_left.svg": 6586,
	"./icon_arrow_right.svg": 6673,
	"./icon_back.svg": 898,
	"./icon_bulk_upload.svg": 6413,
	"./icon_close.svg": 7189,
	"./icon_close_image.svg": 3743,
	"./icon_dashboard.svg": 9965,
	"./icon_delete.svg": 7354,
	"./icon_delete_alt.svg": 1930,
	"./icon_dropdown.svg": 588,
	"./icon_edit.svg": 919,
	"./icon_eye.svg": 642,
	"./icon_eye_slash.svg": 9020,
	"./icon_fabrics.svg": 235,
	"./icon_information.svg": 4067,
	"./icon_logout.svg": 9485,
	"./icon_master.svg": 4397,
	"./icon_more.svg": 844,
	"./icon_preview_image.svg": 1579,
	"./icon_search.svg": 1743,
	"./icon_settings.svg": 6884,
	"./icon_transaction.svg": 5941,
	"./icon_upload.svg": 400,
	"./placket/placket.svg": 1952,
	"./placket/placket_french.svg": 4919,
	"./placket/placket_hidden.svg": 3387,
	"./placket/placket_standard.svg": 5904,
	"./pleats/pleats.svg": 8415,
	"./pleats/pleats_french.svg": 8971,
	"./pleats/pleats_hidden.svg": 2439,
	"./pleats/pleats_standard.svg": 6508,
	"./qr.svg": 6690,
	"./report_logo.svg": 517,
	"./sleeve/long.svg": 7092,
	"./sleeve/short.svg": 3068,
	"./sleeve/sleeve.svg": 5382
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;